const formatTravelReason = (travelReason, content) => {
    if (travelReason === "Others" && !content) {
        return "for personal reasons";
    }
    return travelReason;
};


const renterPrompt = {
    rentRequestMessage: ({ tripStart, tripEnd, content, travelReason, hostName }) => {
        const finalReason = formatTravelReason(travelReason, content);
        return `
      You are a professional booking assistant.Generate a polite booking messages for a rent cars host.  
      Include tripStart, tripEnd, content, reason for travel, and user content.
      Details:
      - tripStart: ${tripStart}
      - tripEnd: ${tripEnd}
      - Content: ${content}
      - Host name:${hostName}
      - Travel Reason: ${finalReason}
      Rules:
      1. 1–5 sentences, friendly and professional.Do not add extra info.Use first-person ("I"/"we") based on guest count and avoid third person pronouns. 
      2. Start each message with "Hi ${hostName}" if provided and Output strictly JSON: { "message": "..." } with no extra text.`
    },

    contactHostMessage: ({ tripStart, tripEnd, content, hostName, reasonForTravel }) => {
        const finalReason = formatTravelReason(reasonForTravel, content);
        return `
       You are a professional booking assistant.
       Generate  short, polite booking messages to a rent a car host in ** valid JSON ** format: { "message": "..." }
       Details to include(rephrased naturally):
        - tripStart: ${tripStart}
        - tripEnd: ${tripEnd}
        - Guests: ${guestCount}
        - Extra content: ${content}
        - Host name: ${hostName}
        -Travel Reason: ${finalReason}
        Rules:
        1. Each message: 1–5 sentences(max 1,000 characters) and sentence must be Friendly, professional, easy to understand.
       2.Use ** "I/my" ** if 1 guest, ** "we/our" ** if multiple guests.
       3.Start with "Hi ${hostName}"(if provided).Clearly mention tripStart / tripEnd dates, guest count, and travel reason.`
    }
};

export default renterPrompt;
